import React from 'react'

export default function Teamphotosection() {
    return (
        <div className="row">
          <div className="col-10 sm-10 mx-auto">
            <div class="card-group">
            
  <div class="card">
    <img src="https://images.pexels.com/photos/5584356/pexels-photo-5584356.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" class="card-img-top" alt="..."/>
    <div class="card-body">
      <h5 class="card-title">Samarth</h5>
      <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This content is a little bit longer.</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
  <div class="card">
    <img src="https://images.pexels.com/photos/5411877/pexels-photo-5411877.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" class="card-img-top" alt="..."/>
    <div class="card-body">
      <h5 class="card-title">Joel</h5>
      <p class="card-text">This card has supporting text below as a natural lead-in to additional content.</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
  <div class="card">
    <img src="https://images.pexels.com/photos/3220360/pexels-photo-3220360.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500" class="card-img-top" alt="..."/>
    <div class="card-body">
      <h5 class="card-title">Lea</h5>
      <p class="card-text">This is a wider card with supporting text below as a natural lead-in to additional content. This card has even longer content than the first to show that equal height action.</p>
      <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
    </div>
  </div>
</div>
          </div>
        </div>
    )
}
